module.exports = __webpack_public_path__ + "static/media/kc_birds.949e20c3.jpg";